import React from 'react';
import { centerStyle } from './styles';
import { toDomStyle } from '@/util/domStyle';

import type { VariantProps } from '@gluestack-ui/nativewind-utils';

type ICenterProps = React.ComponentPropsWithoutRef<'div'> &
  VariantProps<typeof centerStyle>;

const Center = React.forwardRef<HTMLDivElement, ICenterProps>(
  ({ className, style, ...props }, ref) => {
    return (
      <div
        className={centerStyle({ class: className })}
        {...props}
        style={toDomStyle(style)}
        ref={ref}
      />
    );
  }
);

Center.displayName = 'Center';

export { Center };
